import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'gatsby';
import { Card, CardContent, Typography } from '@material-ui/core';
import { useMediaQueries } from '../../hooks/useMediaQueries';

const useStyles = makeStyles({
    card: {
        display: 'inline-block',
        width: '100%',
        height: '200px',
        boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.5)',
        borderRadius: '1px',
    },
    mobileCard: {
        display: 'inline-block',
        width: '100%',
        boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.5)',
        borderRadius: '1px',
    },
    title: {
        paddingTop: '0.5em',
    },
    pos: {
        marginBottom: 12,
    },
});

const DynamicCard = ({ title, path, content }) => {
    const classes = useStyles();
    const isSmallDisplay = useMediaQueries('sm');

    return (
        <Card className={!isSmallDisplay ? classes.card : classes.mobileCard}>
            <CardContent>
                <Typography className={classes.title} variant="headline" component="h2">
                    <Link to={path}>{title}</Link>
                </Typography>
                <Typography component="p">{content}</Typography>
            </CardContent>
        </Card>
    );
};

DynamicCard.propTypes = {
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
};

export default DynamicCard;
